import { defineComponent as _defineComponent } from 'vue'
import { Ref, ref, inject } from 'vue';
import { AlertModalInjection, LoadingModalInjection } from '@/infra/constants/injections';
import CommonModal from './CommonModal.vue';
import LoadingModal from '@/components/modals/LoadingModal.vue';
import AlertModal from '@/components/modals/AlertModal.vue';
import CommonInput from '@/components/CommonInput.vue';
import CommonButton from '@/components/CommonButton.vue';
import AvatarCard from '@/components/AvatarCard.vue';
import { useCreateBranch } from '@/stores/settings/create_branch_store';
import { BranchAddresses } from '@/models/branch_addresses_model';
import CommonToggle from '@/components/CommonToggle.vue';
import AddressSelector from '../custom_selector/AddressSelector.vue';
import StateSelector from '../custom_selector/StateSelector.vue';
import CitySelector from '../custom_selector/CitySelector.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateBranchModal',
  setup(__props, { expose: __expose }) {

const createBranchModal = ref<InstanceType<typeof CommonModal>>();
const alertModal = inject<Ref<InstanceType<typeof AlertModal>>>(AlertModalInjection);
const loadingModal = inject<Ref<InstanceType<typeof LoadingModal>>>(LoadingModalInjection);
const addressSelector = ref<InstanceType<typeof AddressSelector>>();
const stateSelector = ref<InstanceType<typeof StateSelector>>();
const citySelector = ref<InstanceType<typeof CitySelector>>();

const createBranch = useCreateBranch();

const onCreateMethod = ref<((newBranch: BranchAddresses | null) => void) | null>(null);

__expose({
  open: async (params?: {
    zIndex?: number;
    onCreate?: (newBranch: BranchAddresses | null) => void;
  }) => {
    addressSelector.value?.clearOptions();
    stateSelector.value?.setSelected(createBranch.address.getState());
    citySelector.value?.setSelected(createBranch.address.getState(), createBranch.address.getCity());
    onCreateMethod.value = params?.onCreate ?? null;
    await createBranchModal.value?.open({
      zIndex: params?.zIndex ?? 2,
    });
  },
  close: () => {
    clearAll();
    createBranchModal.value?.close();
  },
});

async function createNewBranch() {
  try {
    loadingModal?.value?.open({ zIndex: 1000 });
    const res = await createBranch.submit();
    if (!res) return;
    if (res.isError()) alertModal?.value?.open({ title: 'Erro', content: res.getError() ?? 'Erro desconhecido' });
    else {
      onCreateMethod.value?.call(null, res.getValue() ?? null);
      clearAll();
      createBranchModal.value?.close();
    }
  } finally {
    loadingModal?.value?.close();
  }
}

async function avatarEdit() {
  return null;
}

function clearAll() {
  addressSelector.value?.clearOptions();
  stateSelector.value?.clearSelection();
  citySelector.value?.clearSelection();
  createBranch.$reset();
}


const __returned__ = { createBranchModal, alertModal, loadingModal, addressSelector, stateSelector, citySelector, createBranch, onCreateMethod, createNewBranch, avatarEdit, clearAll, CommonModal, CommonInput, CommonButton, AvatarCard, CommonToggle, AddressSelector, StateSelector, CitySelector }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})